import React from 'react';
import PropTypes from 'prop-types';
import ReduxStateUpdater from './ReduxStateUpdater';
import AddMultipleOrganOffersModal from './views/modals/AddMultipleOrganOffersModal';
import {connect} from 'react-redux';
import {
	closeAcceptOrganOfferModal,
	closeAddMultipleOrganOffersModal,
	closeChangeRecipientsModal,
	closeDeclineOrganOfferModal,
	closeGrantAnonymousAccessModal,
	closeMessageModal,
	closeNotificationModal
} from './redux/actions/foedus';
import {Body, getStore, Header} from 'simplifyworks-core-ui';
import { Badge } from 'react-bootstrap';
import { GoBug } from 'react-icons/go';
import i18n from 'i18next';
import ChangeRecipientsModal from './views/modals/ChangeRecipientsModal';
import AcceptOrganOfferModal from './views/modals/AcceptOrganOfferModal';
import DeclineOrganOfferModal from './views/modals/DeclineOrganOfferModal';
import GrantAnonymousAccessModal from './views/modals/GrantAnonymousAccessModal';
import NotificationModal from './views/modals/NotificationModal';
import MessageModal from './views/modals/MessageModal';

/**
 * Template represents base template for whole application.
 */

const Template = (
	{
		title,
		main,
		addMultipleOrganOffersModalOpen,
		changeRecipientsModalOpen,
		notificationModalOpen,
		messageModalOpen,
		acceptOrganOfferModalOpen,
		declineOrganOfferModalOpen,
		grantAnonymousAccessModalOpen
	}
) => {

	console.warn(globalParams);

	const isStaging = window.location.hostname.includes('staging.foedus-eoeo.eu') || window.location.hostname.includes('auth.staging.foedus-eoeo.eu');

	return (
		<div>

			{/*Docasny kod kym sa test chova ako prod kvoli testovaniu odosielania mailov. TODO: Po prechode do produkcie zmazat!!!*/}
			{isStaging ? (
				<div id='sify-environment-line' className={'sify-env-test'} style={{height: '17px', backgroundColor: '#464646', position: 'relative', width: '100%'}}>
					<h4 style={{margin: 'auto', textAlign: 'center'}}>
						<Badge style={{
							backgroundColor: '#FAFFFF',
							position: 'relative',
							zIndex: 102,
							color: '#265a88',
							paddingRight: '8px',
							verticalAlign: 'top'
						}}>
							<GoBug/> {' ' + i18n.t('env-staging')}
						</Badge>
					</h4>
					<div className='floating'>
						<Badge style={{
							backgroundColor: '#265a88',
							position: 'relative',
							zIndex: 102,
							color: 'white',
							padding: '5px 5px 0px 5px',
							verticalAlign: 'top',
							height: 'inherit'
						}}>
							<GoBug/> {' ' + i18n.t('env-staging')}
						</Badge>
					</div>
				</div>
			) : null}

			<Header title={title}/>
			<Body main={
				<>
					{main}
					<ReduxStateUpdater/>
					<AddMultipleOrganOffersModal
						show={addMultipleOrganOffersModalOpen}
						close={() => getStore().dispatch(closeAddMultipleOrganOffersModal())}
					/>
					<ChangeRecipientsModal
						show={changeRecipientsModalOpen}
						close={() => getStore().dispatch(closeChangeRecipientsModal())}
					/>
					<NotificationModal
						show={notificationModalOpen}
						close={() => getStore().dispatch(closeNotificationModal())}
					/>
					<MessageModal
						show={messageModalOpen}
						close={() => getStore().dispatch(closeMessageModal())}
					/>
					<AcceptOrganOfferModal
						show={acceptOrganOfferModalOpen}
						close={() => getStore().dispatch(closeAcceptOrganOfferModal())}
					/>
					<DeclineOrganOfferModal
						show={declineOrganOfferModalOpen}
						close={() => getStore().dispatch(closeDeclineOrganOfferModal())}
					/>
					<GrantAnonymousAccessModal
						show={grantAnonymousAccessModalOpen}
						close={() => getStore().dispatch(closeGrantAnonymousAccessModal())}
					/>
				</>
			}/>
		</div>
	);
};

Template.propTypes = {
	// Page title
	title: PropTypes.node.isRequired,
	// Main content
	main: PropTypes.node.isRequired
};

const mapStateToProps = (state, ownProps) => {
	return {
		addMultipleOrganOffersModalOpen: state.foedus.addMultipleOrganOffersModalOpen,
		changeRecipientsModalOpen: state.foedus.changeRecipientsModalOpen,
		notificationModalOpen: state.foedus.notificationModalOpen,
		messageModalOpen: state.foedus.messageModalOpen,
		acceptOrganOfferModalOpen: state.foedus.acceptOrganOfferModalOpen,
		declineOrganOfferModalOpen: state.foedus.declineOrganOfferModalOpen,
		grantAnonymousAccessModalOpen: state.foedus.grantAnonymousAccessModalOpen
	};
};

export default connect(mapStateToProps)(Template);
